import Component from '@glimmer/component';
import { action } from '@ember/object';
import { sortBy, uniqueValues } from '../../utils/array-helpers';
import CompetencyTitleEditor from './competency-title-editor';
import { and, eq } from 'ember-truth-helpers';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import NewCompetency from './new-competency';
import t from 'ember-intl/helpers/t';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

export default class SchoolCompetenciesManagerComponent extends Component {
  get domains() {
    if (!this.args.competencies) {
      return [];
    }

    return this.args.competencies.filter((competency) => {
      return !competency.belongsTo('parent').id();
    });
  }

  get filteredDomains() {
    return uniqueValues(this.domains).map((domain) => {
      if (!domain.id) {
        return {
          domain,
          competencies: [],
        };
      }
      const domainCompetencies = this.args.competencies.filter(
        (competency) => competency.belongsTo('parent').id() === domain.id,
      );
      return {
        domain,
        competencies: sortBy(domainCompetencies, 'title'),
      };
    });
  }

  get sortedDomains() {
    return sortBy(this.filteredDomains, 'domain.title');
  }

  @action
  changeCompetencyTitle(value, competency) {
    competency.set('title', value);
  }
  <template>
    <div class="school-competencies-manager" data-test-school-competencies-manager ...attributes>
      {{#each this.sortedDomains as |obj|}}
        <div class="domain" data-test-domain>
          <div class="block" data-test-domain-details>
            <CompetencyTitleEditor @competency={{obj.domain}} @canUpdate={{@canUpdate}} />
            {{#if
              (and
                @canDelete
                (eq obj.domain.programYearObjectives.length 0)
                (eq obj.competencies.length 0)
              )
            }}
              <button
                type="button"
                class="link-button delete-button"
                aria-label={{t "general.remove"}}
                {{on "click" (fn @remove obj.domain)}}
                data-test-remove-domain
              >
                <FaIcon @icon={{faTrash}} class="enabled remove" />
              </button>
            {{else}}
              <button
                type="button"
                class="link-button delete-button"
                aria-label={{t "general.remove"}}
                disabled
                data-test-remove-domain
              >
                <FaIcon
                  @icon={{faTrash}}
                  @title={{t "general.canNotDeleteSchoolCompetencyDomain"}}
                  class="disabled"
                />
              </button>
            {{/if}}
          </div>
          <ul>
            {{#each obj.competencies as |competency|}}
              <li class="block" data-test-competency>
                <CompetencyTitleEditor @competency={{competency}} @canUpdate={{@canUpdate}} />
                {{#if (and @canDelete (eq competency.programYearObjectives.length 0))}}
                  <button
                    type="button"
                    class="link-button delete-button"
                    aria-label={{t "general.remove"}}
                    {{on "click" (fn @remove competency)}}
                    data-test-remove-competency
                  >
                    <FaIcon @icon={{faTrash}} class="enabled remove" />
                  </button>
                {{else}}
                  <button
                    type="button"
                    class="link-button delete-button"
                    aria-label={{t "general.remove"}}
                    disabled
                    data-test-remove-competency
                  >
                    <FaIcon
                      @icon={{faTrash}}
                      @title={{t "general.canNotDeleteSchoolCompetency"}}
                      class="disabled"
                    />
                  </button>
                {{/if}}
              </li>
            {{/each}}
            {{#if (and obj.domain.id @canCreate)}}
              <li>
                <NewCompetency @add={{fn @add obj.domain}} />
              </li>
            {{/if}}
          </ul>
        </div>
      {{/each}}
      {{#if @canCreate}}
        <div data-test-new-domain>
          <h3 class="new-domain">
            {{t "general.newDomain"}}
          </h3>
          <NewCompetency @add={{fn @add null}} />
        </div>
      {{/if}}
    </div>
  </template>
}
